// extracted by mini-css-extract-plugin
module.exports = {"hint":"hint_hint_rinMG","icon":"hint_icon_3nWM5"};